import { render, staticRenderFns } from "./index.vue?vue&type=template&id=11901ffa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=11901ffa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11901ffa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11901ffa')) {
      api.createRecord('11901ffa', component.options)
    } else {
      api.reload('11901ffa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=11901ffa&scoped=true", function () {
      api.rerender('11901ffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DragSelect/index.vue"
export default component.exports